import { Injectable } from "@angular/core";
import { AppConfigService } from './appConfig.service';

@Injectable()
export class OantutiService {
    constructor(private configService: AppConfigService) { }
    init1s(data = {}, nav: any) {
        data["flag"] = 'Init';
        return this.configService.init1s(data, nav);
    }

    getBalanceMain(data = {}, nav: any) {
        data["flag"] = 'balance';
        return this.configService.getBalanceMain(data, nav);
    }

    bettingOantuti(data = {}, nav: any) {
        return this.configService.bettingOantuti(data, nav);
    }
}


// WEBPACK FOOTER //
// ./src/services/oantuti.services.ts